import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { DefaultPageProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';
import HomeButton from 'src/components/atoms/button/HomeButton';

type Props = DefaultPageProps;

class ShopSuccessPage extends Component<Props> {
  render() {
    const msg = this.props.history.location.state?.method === 'UPDATE' ? '更新' : '登録';
    return (
      <DefaultLayout {...this.props}>
        <Styled>
          <div>
            <Heading>
              ＼ お店の基本情報を<span>{msg}</span>しました ／
            </Heading>
            <Lead>sacriのアプリからご確認ください</Lead>
            <Controller>
              <HomeButton />
            </Controller>
          </div>
        </Styled>
      </DefaultLayout>
    );
  }
}

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 52px);
`;

const Heading = styled.h3`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 18px;
  text-align: center;
`;
const Lead = styled.p`
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  font-size: 14px;
  line-height: ${24 / 14};
  text-align: center;
  margin-top: 16px;
`;
const Controller = styled.div`
  margin-top: 40px;
  > * {
    margin-top: 16px;
  }
`;

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ShopSuccessPage);
